import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth-module';
import twoFactor from './modules/two-factor-module';
import settings from './modules/settings-module';
import progress from './modules/progress-module';
import users from './modules/user-module';
import airports from './modules/airports-module';
import subjects from './modules/subjects-module';
import zones from './modules/zones-module';
import workPlaces from './modules/work-places-module';
import livingAddresses from './modules/living-addresses-module';
import documents from './modules/documents-module';
import permits from './modules/permits-module';
import permitFields from './modules/permit-fields-module';
import permitStatistics from './modules/permit-statistics-module';
import countries from './modules/countries-module';
import permitPrices from './modules/permit-prices-module';
import expiration from './modules/token-expiration-module';
import loginHistory from './modules/login-history-module';
import changeHistory from './modules/change-history-module';
import permitCards from './modules/permit-cards-module';
import trainingResults from './modules/training-results-module';
import ipAddresses from './modules/banned-ip-addresses-module';
import permitCardCounter from './modules/permit-card-counters-module';
import approveParkingInfo from './modules/approve-permit-module';
import permitsImport from './modules/permits-import-module';
import emailLogs from './modules/email-logs-module';
import permitIssues from './modules/permit-issues-module';
import issuedVehiclePermits from './modules/issued-vehicle-permits-module';
import unauthorizedAttempts from './modules/unauthorized-attempts-module';
import backgroundChecks from './modules/background-checks-module';
import checkInHistory from './modules/location-check-in-history-module';
import locations from './modules/locations-module';
import locationsBatchJobs from './modules/locations-batch-jobs-module';
import userCodes from './modules/user-codes-module';
import impeccableReputationChecks from './modules/impeccable-reputation-checks-module';
import printList from './modules/print-list-module';
import printReport from './modules/print-report-module';
import systemSettings from './modules/system-settings-module';
import systemLogFiles from './modules/system-log-files-module';
import drivingPermits from './modules/driving-permits-module';
import drivingPracticeExams from './modules/driving-practice-exams-module';
import questionnaires from './modules/questionnaires-module';
import drivingPracticeExamParticipants from './modules/driving-practice-exam-participants-module';
import drivingPermitStatistics from './modules/driving-permit-statistics-module';
import drivingPermitsImport from './modules/driving-permits-import-module';
import rejectedPermits from './modules/rejected-permits-module';
import exams from './modules/exams-module';
import settingsDrivingPermits from './modules/settings-driving-permits-module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},

  mutations: {},

  actions: {},

  modules: {
    auth,
    settings,
    progress,
    users,
    airports,
    subjects,
    zones,
    workPlaces,
    livingAddresses,
    documents,
    permits,
    permitFields,
    permitStatistics,
    countries,
    permitPrices,
    expiration,
    loginHistory,
    changeHistory,
    permitCards,
    trainingResults,
    ipAddresses,
    permitCardCounter,
    approveParkingInfo,
    permitsImport,
    emailLogs,
    permitIssues,
    issuedVehiclePermits,
    unauthorizedAttempts,
    backgroundChecks,
    checkInHistory,
    locations,
    userCodes,
    impeccableReputationChecks,
    printList,
    printReport,
    systemSettings,
    systemLogFiles,
    drivingPermits,
    drivingPracticeExams,
    questionnaires,
    drivingPracticeExamParticipants,
    drivingPermitStatistics,
    drivingPermitsImport,
    rejectedPermits,
    exams,
    settingsDrivingPermits,
    twoFactor,
    locationsBatchJobs,
  },
});
